import { render, staticRenderFns } from "./AssignQuerylogsForm.vue?vue&type=template&id=16ee02b2&"
import script from "./AssignQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./AssignQuerylogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports